// src/components/RoleGuard.tsx
import React from 'react';
import { useAuth } from '../contexts/AuthContext';

interface RoleGuardProps {
  roles?: string | string[];
  permissions?: string | string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const RoleGuard: React.FC<RoleGuardProps> = ({
  roles,
  permissions,
  children,
  fallback = null,
}) => {
  const { isRole, hasPermission } = useAuth();

  // ✅ Roles
  const hasRequiredRole = roles
    ? Array.isArray(roles)
      ? roles.length > 0 && isRole(roles)
      : isRole(roles)
    : true;

  // ✅ Permissions
  const hasRequiredPermission = permissions
    ? Array.isArray(permissions)
      ? permissions.some((p) => hasPermission(p))
      : hasPermission(permissions)
    : true;

  if (hasRequiredRole && hasRequiredPermission) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};

export default RoleGuard;